export const adaptUserPermissionResponse = (response) => {
  return response?.permissions || [];
};
